/**
 * Formazione Service - Servizi per gestione iniziative formative---mod
 */

import { protectedApi } from './api';
import { API_ENDPOINTS } from '../config/apiConfig';

/**
 * Recupera l'elenco delle iniziative di for  mazione
 * @returns {Promise<Object>} Lista iniziative
 */
export const getIniziative = async () => {
  try {
    console.log('[formazioneService] Chiamata POST /api/Eventi/getIniziative');

    const response = await protectedApi.post(API_ENDPOINTS.FORMAZIONE.INIZIATIVE);

    console.log('[formazioneService] Risposta iniziative:', response.data);
    const { data, code, success, message } = response.data;

    if (!success || code !== 200) {
      throw new Error(message || 'Recupero iniziative fallito');
    }

    return { success: true, data, message, code };
  } catch (error) {
    console.error('[formazioneService] Errore recupero iniziative:', error);
    const errorMessage =
      error.response?.data?.message ||
      error.message ||
      'Errore durante il recupero delle iniziative';
    const code = error.response?.data?.code || error.response?.status || 500;
    const success = error.response?.data?.success || false;

    return { success, message: errorMessage, code };
  }
};

/**
 * Recupera i dettagli di una singola iniziativa
 * @param {string|number} id - ID dell'iniziativa
 * @returns {Promise<Object>} Dettagli iniziativa
 */
export const getIniziativa = async (id) => {
  try {
    console.log(`[formazioneService] Chiamata POST /api/Eventi/getIniziativa/${id}`);

    const response = await protectedApi.post(`/api/Eventi/getIniziativa/${id}`);

    console.log('[formazioneService] Risposta dettaglio iniziativa:', response.data);
    const { data, code, success, message } = response.data;

    if (!success || code !== 200) {
      throw new Error(message || 'Recupero dettaglio iniziativa fallito');
    }

    return { success: true, data, message, code };
  } catch (error) {
    console.error('[formazioneService] Errore recupero dettaglio iniziativa:', error);
    const errorMessage =
      error.response?.data?.message ||
      error.message ||
      'Errore durante il recupero del dettaglio iniziativa';
    const code = error.response?.data?.code || error.response?.status || 500;
    const success = error.response?.data?.success || false;

    return { success, message: errorMessage, code };
  }
};

/**
 * Recupera le statistiche formazione per un utente specifico (Admin/Segreteria)
 * @param {number} idAnagrafico
 * @param {number} anno
 */
export const getStats = async (idAnagrafico, anno) => {
  try {
    const response = await protectedApi.get(
      `${API_ENDPOINTS.FORMAZIONE.STATS}/${idAnagrafico}`,
      { params: { anno } }
    );
    const { data, code, success, message } = response.data;
    if (!success || code !== 200) throw new Error(message || 'Stats non disponibili');
    return { success: true, data, message, code };
  } catch (error) {
    return { success: false, message: error.response?.data?.message || error.message };
  }
};

/**
 * Salva una prenotazione per un'iniziativa
 * @param {Object} prenotazioneData - Dati della prenotazione
 * @returns {Promise<Object>} Risultato salvataggio
 */
export const salvaPrenotazione = async (prenotazioneData) => {
  try {
    console.log('[formazioneService] Chiamata POST /api/Eventi/setPrenotazione', prenotazioneData);

    const response = await protectedApi.post('/api/Eventi/setPrenotazione', prenotazioneData);

    console.log('[formazioneService] Risposta salvataggio prenotazione:', response.data);
    const { data, code, success, message } = response.data;

    if (!success || code !== 200) {
      throw new Error(message || 'Salvataggio prenotazione fallito');
    }

    return { success: true, data, message, code };
  } catch (error) {
    console.error('[formazioneService] Errore salvataggio prenotazione:', error);
    const errorMessage =
      error.response?.data?.message ||
      error.message ||
      'Errore durante il salvataggio della prenotazione';
    const code = error.response?.data?.code || error.response?.status || 500;
    const success = error.response?.data?.success || false;

    return { success, message: errorMessage, code };
  }
};